import { Component, OnInit } from '@angular/core';
import { AnnonceService } from '../annonce.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-annonce-attente-by-id',
  templateUrl: './annonce-attente-by-id.component.html',
  styleUrls: ['./annonce-attente-by-id.component.scss']
})
export class AnnonceAttenteByIdComponent implements OnInit {
  annonce: any;
  id: any
  constructor(private annonceService: AnnonceService, private route: ActivatedRoute, public router: Router) { }

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');

    this.annonceService.getAnnonceDetails(this.id).subscribe((Response: any) => {
      this.annonce = Response.annonce
      console.log(this.annonce)
    })
  }
  approuveAnnonce() {
    Swal.fire({
      title: 'Êtes-vous sûr(e) ?',
      text: "Voulez-vous approuver cette annonce ?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, approuver !',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        this.annonceService.approveAnnouncement(this.id).subscribe((data: any) => {
          Swal.fire(
            'Approuvée !',
            "L'annonce a été approuvée avec succès.",
            'success'
          );
          this.router.navigate(['/annonceAttente']);
        });
      }
    });
  }

  deleteAgencies(id) {
    Swal.fire({
      title: "Êtes-vous sûr(e) ?",
      text: "Vous ne pourrez pas revenir en arrière !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimez-le."
    }).then((result) => {
      if (result.isConfirmed) {
        this.annonceService.deleteItem(id).subscribe((response: any) => {
          console.log(response);

          // If you want to show a success message after the deletion, use another Swal.fire here
          Swal.fire({
            title: "Supprimé!",
            text: "Votre agence a été supprimée.",
            icon: "success"
          });
          // this.annonce.splice(i, 1)
          this.router.navigate(['/annonceAttente']);

          // Fetch the updated data after deletion
          // setTimeout(() => {
          //   this.getagencesTunis();
          // }, 500);

        });
      }
    });
  }
}
